import React from 'react';

import Carousel, { CarouselRenderProps } from 'components/Carousel';
import Dialog, { DialogProps } from 'components/Dialog';
import Image from 'components/Image';
import ChevronLeftIcon from 'icons/chevron-left.svg';
import ChevronRightIcon from 'icons/chevron-right.svg';
import { cx } from 'utils';
import styles from './Lightbox.module.css';

export interface LightboxProps extends DialogProps {
  images: string[];
  startIndex?: number;
}

const Lightbox: React.FCWithChildren<LightboxProps> = ({
  images,
  startIndex = 0,
  ...dialogProps
}) => {
  const { onClose } = dialogProps;

  return (
    <Dialog backdropProps={{ className: styles.backdrop }} {...dialogProps}>
      <div className={styles.root}>
        <div className={cx(styles.content)}>
          <Carousel
            enableKeyboardNavigation
            options={{ draggable: false, startIndex }}
            hideControls
            controls={({ scrollPrev, scrollNext, selectedIndex }: CarouselRenderProps) => (
              <>
                <p className={cx(styles.control, styles.page)}>{`${selectedIndex + 1}/${
                  images.length
                }`}</p>
                <button className={cx(styles.control, styles.close)} onClick={onClose}>
                  CLOSE
                </button>
                <button
                  className={cx(styles.control, styles.previous)}
                  onClick={() => {
                    scrollPrev();
                  }}
                >
                  <ChevronLeftIcon />
                </button>
                <button
                  className={cx(styles.control, styles.next)}
                  onClick={() => {
                    scrollNext();
                  }}
                >
                  <ChevronRightIcon />
                </button>
              </>
            )}
          >
            {() => {
              return images.map((src, index) => {
                return (
                  <Image
                    key={index}
                    alt="zoomable"
                    aspectRatio="letterbox"
                    src={src}
                    className={styles.imageContainer}
                  />
                );
              });
            }}
          </Carousel>
        </div>
      </div>
    </Dialog>
  );
};

export default Lightbox;
